__turbopack_context__.v({
  "drawer": "PriceDrawer-module-scss-module__TeWMNq__drawer",
  "electricity": "PriceDrawer-module-scss-module__TeWMNq__electricity",
  "gas": "PriceDrawer-module-scss-module__TeWMNq__gas",
  "min-instalment-warning": "PriceDrawer-module-scss-module__TeWMNq__min-instalment-warning",
  "price": "PriceDrawer-module-scss-module__TeWMNq__price",
  "price-details": "PriceDrawer-module-scss-module__TeWMNq__price-details",
  "price-details-content": "PriceDrawer-module-scss-module__TeWMNq__price-details-content",
  "price-details-header": "PriceDrawer-module-scss-module__TeWMNq__price-details-header",
  "price-details-row": "PriceDrawer-module-scss-module__TeWMNq__price-details-row",
  "price-details-table": "PriceDrawer-module-scss-module__TeWMNq__price-details-table",
  "price-details-wrapper": "PriceDrawer-module-scss-module__TeWMNq__price-details-wrapper",
  "price-drawer": "PriceDrawer-module-scss-module__TeWMNq__price-drawer",
  "price-list-button": "PriceDrawer-module-scss-module__TeWMNq__price-list-button",
  "price-wrapper": "PriceDrawer-module-scss-module__TeWMNq__price-wrapper",
});
